import ManageSystemMessagesPage from './ManageSystemMessagesPage';
import { checkUserRole } from '../../Auth';
import { UserRole } from '../../../models';

export default checkUserRole(ManageSystemMessagesPage, [UserRole.superAdmin, UserRole.admin], '/admin');
export { default as reducer } from './systemMessages.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageSystemMessagesPage/index.ts